import _ from 'lodash';
import {fullName} from 'shared/tools/fullName';
/*global window */

class CoreAuth {
  constructor(auth) {
    _.merge(this, auth);

    _.set(this, 'user.name', fullName(this.user || {}));
  }
}

const coreAuth = new CoreAuth(window.auth);

export default coreAuth;
